import React, { useState } from 'react';
import DefaultLayout from 'components/DefaultLayout';
import { Button, Input, Select, Table } from 'ui';
import { pages } from 'constants/pages';
import { useIntl } from 'react-intl';
import { ButtonList, StyledPage } from 'styles/layout/table';
import Filter from 'components/Filter';
import { Form } from 'antd';
import useQueryApiClient from 'utils/useQueryApiClient';
import { HeaderButtonType } from 'constants/enums';
import PortalSectionSelect, {labelMap} from 'components/Selects/PortalSectionSelect';

export interface MapLayerType {
  description: string;
  id: number;
  isPublic: boolean;
  name: string;
  type: HeaderButtonType;
  url: string;
}

const MapLayers = () => {
  const [filter, setFilter] = useState<any>([]);
  const [reload, setReload] = useState<number>(0);
  const [selectedKeys, setSelectedKeys] = useState<number[]>([]);

  const intl = useIntl();
  const [form] = Form.useForm();
  const { appendData: deleteLayers } = useQueryApiClient({
    request: {
      url: `api/v1/map-layers`,
      method: 'DELETE',
    },
    onSuccess: () => {
      setReload((old) => old + 1);
      setSelectedKeys([]);
    },
  });

  const columns = [
    {
      title: intl.formatMessage({ id: 'general.name' }),
      dataIndex: 'name',
    },
    {
      title: intl.formatMessage({ id: 'general.public' }),
      dataIndex: 'isPublic',
      render: (isPublic: boolean) =>
        isPublic ? intl.formatMessage({ id: 'general.yes' }) : intl.formatMessage({ id: 'general.no' }),
    },
    {
      title: intl.formatMessage({ id: 'map_layers.field_type_label' }),
      dataIndex: 'type',
      render: (code: HeaderButtonType) => intl.formatMessage({id: labelMap[code]})
    },
    {
      title: intl.formatMessage({ id: 'map_layers.field_url_label' }),
      dataIndex: 'url',
    },
  ];

  return (
    <DefaultLayout.PageLayout>
      <DefaultLayout.PageContent>
        <StyledPage>
          <DefaultLayout.PageHeader
            title={intl.formatMessage({ id: pages.mapLayers.title })}
            breadcrumb={[
              {
                path: '/',
                name: intl.formatMessage({ id: 'general.administration' }),
              },
            ]}
          />
          <Filter
            form={form}
            filter={
              <>
                <Input name="name" label={intl.formatMessage({ id: 'general.name' })} />
                <PortalSectionSelect name="type" label={intl.formatMessage({ id: 'map_layers.field_type_label' })} />
                <Select
                  name="isPublic"
                  label={intl.formatMessage({ id: 'general.public' })}
                  allowClear
                  showSearch={false}
                  options={[
                    {
                      label: intl.formatMessage({ id: 'general.yes' }),
                      value: 'true',
                    },
                    {
                      label: intl.formatMessage({ id: 'general.no' }),
                      value: 'false',
                    },
                  ]}
                />
              </>
            }
            setFilter={setFilter}
          />
          <div className="theme-container">
            <Table
              url="api/v1/map-layers"
              columns={columns}
              filter={filter}
              defaultOrder="asc"
              defaultSort="name"
              rowClassName="clickable-row"
              linkProps={{
                url: pages.mapLayers.edit.url,
              }}
              reload={reload}
              enableSelectedRow
              setSelectedKeys={setSelectedKeys}
              tableActions={
                <ButtonList>
                  <Button
                    label={intl.formatMessage({ id: 'general.delete_chosen' })}
                    onClick={() => deleteLayers({ ids: selectedKeys })}
                    disabled={!selectedKeys.length}
                  />
                  <Button
                    type="primary"
                    label={intl.formatMessage({ id: 'general.add_new' })}
                    href={pages.mapLayers.create.url}
                  />
                </ButtonList>
              }
            />
          </div>
        </StyledPage>
      </DefaultLayout.PageContent>
    </DefaultLayout.PageLayout>
  );
};

export default MapLayers;
